import { ReactNode } from "react";
import { Redirect } from "wouter";
import { useAuth } from "@/hooks/use-auth";

interface AdminOnlyRouteProps {
  children: ReactNode;
}

export function AdminOnlyRoute({ children }: AdminOnlyRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00444C]"></div>
      </div>
    );
  }

  // Redirect non-admin users to unauthorized page
  if (user && user.role !== "admin") {
    return <Redirect to="/unauthorized" />;
  }

  return <>{children}</>;
}
